import React from 'react';

const Whistleblow = () => {
    return (
        <div className="text-center py-16">
            <i className="fa fa-id-badge text-amber-500 text-6xl mb-4"></i>
            <h3 className='font-bold text-2xl'>Report on any Misconduct</h3>
            <p className=''>All reports are anonymous and confidential.</p>
            <span className='text-amber-500 font-bold text-sm uppercase underline underline-offset-4'>Coming Soon</span>
        </div>
    )
}

export default Whistleblow;